"use client"

import { ComponentConfig } from "@measured/puck"
import { Image } from "antd"
import { configs, DefaultImage } from "../../../../external-components"

export type SectionQTTuyenDungProps = {
  items: {
    id?: number
    image?: string
    text1?: string
  }[]
  height?: number
}

const Images = {
  slitem1: "../../../../../../../public/images/slitems_1.png",
  slitem2: "../../../../../../../public/images/slitems_2.png",
  slitem3: "../../../../../../../public/images/slitems_3.png",
  slitem4: "../../../../../../../public/images/slitems_4.png",
  slitem5: "../../../../../../../public/images/slitems_5.png",
  muiTen: "../../../../../../../public/images/muiTen.png",
}

export const RenderConfig: ComponentConfig<SectionQTTuyenDungProps> = {
  render: ({ items }: { items: SectionQTTuyenDungProps["items"] }) => {
    return (
      <div className="flex flex-col text-[12px] font-semibold px-[15px] mt-[50px] md:hidden">
        <div className="flex flex-row justify-center mb-[20px] items-start">
          <div className="relative w-[25%] flex flex-col justify-center items-center gap-[10px] p-[10px]">
            <img
              className="w-[58px] h-[58px] "
              src={items[0].image ? `${configs.API_URL}${items[0].image}` : DefaultImage}
              alt={`imageCustomer`}
            />
            <Image alt="" height={28} width={28} src={Images.slitem1} />
            <p className="text-center">{items[0].text1}</p>
          </div>
          <div className="w-[12.5%] p-[10px] self-center">
            <Image src={Images.muiTen} alt="" className="max-w-full object-fill h-[49px]" />
          </div>
          <div className="relative w-[25%] flex flex-col justify-center items-center gap-[10px] p-[10px]">
            <img
              className="w-[58px] h-[58px] "
              src={items[1].image ? `${configs.API_URL}${items[1].image}` : DefaultImage}
              alt={`imageCustomer`}
            />
            <Image alt="" height={28} width={28} src={Images.slitem2} />
            <p className="text-center">{items[1].text1}</p>
          </div>
          <div className="w-[12.5%] p-[10px] self-center">
            <Image src={Images.muiTen} alt="" className="max-w-full object-fill h-[49px]" />
          </div>
          <div className="relative w-[25%] flex flex-col justify-center items-center gap-[10px] p-[10px]">
            <img
              className="w-[58px] h-[58px] "
              src={items[2].image ? `${configs.API_URL}${items[2].image}` : DefaultImage}
              alt={`imageCustomer`}
            />
            <Image alt="" height={28} width={28} src={Images.slitem3} />
            <p className="text-center">{items[2].text1}</p>
          </div>
        </div>
        <div className="flex flex-row justify-center items-center mb-[50px]">
          <div className="relative w-[25%] flex flex-col justify-center items-center gap-[10px] p-[10px]">
            <img
              className="w-[58px] h-[58px] "
              src={items[3].image ? `${configs.API_URL}${items[3].image}` : DefaultImage}
              alt={`imageCustomer`}
            />
            <Image alt="" height={28} width={28} src={Images.slitem4} />
            <p className="text-center">{items[3].text1}</p>
          </div>
          <div className="w-[12.5%] p-[10px] self-center">
            <Image src={Images.muiTen} alt="" className="max-w-full object-fill h-[49px]" />
          </div>
          <div className="relative w-[25%] flex flex-col justify-center items-center gap-[10px] p-[10px]">
            <img
              className="w-[58px] h-[58px] "
              src={items[4].image ? `${configs.API_URL}${items[4].image}` : DefaultImage}
              alt={`imageCustomer`}
            />
            <Image alt="" height={28} width={28} src={Images.slitem5} />
            <p className="text-center">{items[4].text1}</p>
          </div>
        </div>
      </div>
    )
  },
}
